import React from "react";
import styled from "styled-components";

const PrivacyWrapper = styled.section`
    background: #e0e0e0;
    color: #222;
    padding: 60px 30px;
`;

const PrivacyContainer = styled.div`
    max-width: 800px;
    margin: 0 auto;
`;

const PrivacyTitle = styled.h1`
    font-size: 34px;
    font-weight: bold;
    color: #8b0000;
    margin-bottom: 25px;
    text-align: center;
`;

const PrivacyText = styled.p`
    font-size: 20px;
    line-height: 1.7;
    margin-bottom: 25px;
`;

const PrivacyList = styled.ul`
    margin: 25px 0;
    padding-left: 25px;
`;

const PrivacyListItem = styled.li`
    font-size: 20px;
    line-height: 1.7;
    margin-bottom: 12px;
`;

const PrivacyPolicy = () => {
    return (
        <PrivacyWrapper>
            <PrivacyContainer>
                <PrivacyTitle>Datenschutzrichtlinie</PrivacyTitle>
                <PrivacyText>
                    Bei **Troniq.news** legen wir großen Wert auf den Schutz Ihrer persönlichen Daten. Diese Datenschutzrichtlinie erklärt, wie wir Informationen sammeln, verwenden und schützen, wenn Sie unsere Plattform nutzen.
                </PrivacyText>

                <PrivacyTitle>1. Informationssammlung</PrivacyTitle>
                <PrivacyText>
                    Wir sammeln verschiedene persönliche Informationen, wenn Sie unsere Dienste nutzen, insbesondere:
                </PrivacyText>
                <PrivacyList>
                    <PrivacyListItem>Ihr Vorname und Nachname</PrivacyListItem>
                    <PrivacyListItem>Ihre E-Mail-Adresse</PrivacyListItem>
                    <PrivacyListItem>Ihre Telefonnummer</PrivacyListItem>
                    <PrivacyListItem>Technische Informationen wie Ihre IP-Adresse und den verwendeten Gerätetyp</PrivacyListItem>
                </PrivacyList>

                <PrivacyTitle>2. Nutzung der Daten</PrivacyTitle>
                <PrivacyText>
                    Ihre Daten werden verwendet, um:
                </PrivacyText>
                <PrivacyList>
                    <PrivacyListItem>unsere Dienste bereitzustellen und zu verbessern</PrivacyListItem>
                    <PrivacyListItem>Sie bei Bedarf zu kontaktieren</PrivacyListItem>
                    <PrivacyListItem>die Sicherheit und den ordnungsgemäßen Betrieb der Plattform zu gewährleisten</PrivacyListItem>
                    <PrivacyListItem> Ihnen Angebote und Aktualisierungen zu senden (mit Ihrer Zustimmung)</PrivacyListItem>
                </PrivacyList>

                <PrivacyTitle>3. Datenweitergabe</PrivacyTitle>
                <PrivacyText>
                    Wir verkaufen oder vermieten Ihre persönlichen Daten nicht. Allerdings können wir diese nur mit vertrauenswürdigen Partnern teilen, um:
                </PrivacyText>
                <PrivacyList>
                    <PrivacyListItem>gesetzlichen Verpflichtungen nachzukommen</PrivacyListItem>
                    <PrivacyListItem>unsere Dienste mithilfe von Analysewerkzeugen zu verbessern</PrivacyListItem>
                    <PrivacyListItem>die Sicherheit unserer Plattform zu gewährleisten</PrivacyListItem>
                </PrivacyList>

                <PrivacyTitle>4. Datensicherheit</PrivacyTitle>
                <PrivacyText>
                    Wir setzen strenge Sicherheitsmaßnahmen ein, um Ihre Informationen vor unbefugtem Zugriff, Änderung oder Offenlegung zu schützen.
                </PrivacyText>

                <PrivacyTitle>5. Ihre Rechte</PrivacyTitle>
                <PrivacyText>
                    Sie haben das Recht auf:
                </PrivacyText>
                <PrivacyList>
                    <PrivacyListItem>Zugriff auf Ihre persönlichen Daten</PrivacyListItem>
                    <PrivacyListItem>Berichtigung oder Löschung Ihrer Informationen zu verlangen</PrivacyListItem>
                    <PrivacyListItem>Ihre Zustimmung jederzeit zu widerrufen</PrivacyListItem>
                    <PrivacyListItem>eine Beschwerde bei einer Datenschutzbehörde einzureichen</PrivacyListItem>
                </PrivacyList>

                <PrivacyTitle>6. Cookies</PrivacyTitle>
                <PrivacyText>
                    Wir verwenden Cookies, um Ihre Erfahrung auf unserer Plattform zu verbessern. Sie können Ihre Cookie-Einstellungen jederzeit im Browser ändern.
                </PrivacyText>

                <PrivacyTitle>7. Änderungen der Richtlinie</PrivacyTitle>
                <PrivacyText>
                    Wir behalten uns das Recht vor, diese Datenschutzrichtlinie jederzeit zu ändern. Alle Änderungen werden auf dieser Seite veröffentlicht.
                </PrivacyText>

                <PrivacyTitle>8. Kontakt</PrivacyTitle>
                <PrivacyText>
                    Bei Fragen zu unserer Datenschutzrichtlinie können Sie uns kontaktieren unter:
                </PrivacyText>
                <PrivacyText>
                    📧 E-Mail: kontakt@troniq.news
                </PrivacyText>
                <PrivacyText>
                    📍 Adresse: 15 Lichtstraße, 10115 Berlin, Deutschland
                </PrivacyText>
            </PrivacyContainer>
        </PrivacyWrapper>
    );
};

export default PrivacyPolicy;